import { JSONObject } from 'global/graphql/scalars.type';
import { InfoBoxText } from '../../info-box/info-box-edit';
import { CAPTION_SETTINGS } from './component-caption';
import ActivityBuilderRichtextToolbar from 'approot/activity-builder/activity-builder-richtext-toolbar';
import { useComponentRichtext } from '../component-richtext.hooks';

export const ComponentCaptionEdit = ({
  caption,
  onChange,
}: {
  caption: JSONObject;
  onChange: (text: JSONObject) => void;
}) => {
  const { editor, toolbarRef, showToolbar } = useComponentRichtext({
    initialValue: caption,
    settings: CAPTION_SETTINGS,
    onChange,
  });

  return (
    <>
      <ActivityBuilderRichtextToolbar
        editor={editor}
        toolbarRef={toolbarRef}
        showToolbar={showToolbar}
      />
      {editor && (
        <InfoBoxText editor={editor} toolbarRef={toolbarRef} isSmall />
      )}
    </>
  );
};
